<template lang="pug">
.number-with-description
  .number(:class='large ? `large`:``')
    template(v-if='useCurrenyFormat')
      | {{ number | currency }}
    template(v-else)
      | {{ number }}
  .description(
    :class='large ? `large`:``'
    v-html='description'
  )
</template>

<script>
export default {
  props: {
    number: {
      default: 0,
    },
    description: {
      default: '...',
    },
    large: {
      default: false,
    },
    useCurrenyFormat: {
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.number-with-description {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  .description {
    font-size: 13px;
    opacity: 0.5;
    letter-spacing: 1px;
    text-align: center;
    text-overflow: clip;
    &.large {
      font-size: 15px;
      font-weight: 500;
    }
  }
  .number {
    font-size: 28px;
    letter-spacing: 2px;
    &.large {
      font-size: 33px;
      font-weight: 500;
    }
  }
}
</style>
